import { PERIOD_OPTIONS } from "../utils/analytics.js";
import styles from "./AppHeader.module.css";

export default function AppHeader({ username, periodDays, onPeriodChange, onNewSearch, onCompare, showPeriod = true }) {
  return (
    <header className={styles.root}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <svg className={styles.mark} viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 13h3v-2H4v2Zm13 0h3v-2h-3v2ZM8.5 16h7v-2h-7v2Zm0-6h7V8h-7v2Zm-1 4.5h-1A2.5 2.5 0 0 1 4 12v0a2.5 2.5 0 0 1 2.5-2.5h1v5Zm9 0h1A2.5 2.5 0 0 0 20 12v0a2.5 2.5 0 0 0-2.5-2.5h-1v5Z" />
          </svg>
          <span className={styles.appName}>
            <span className={styles.appNameCompact}>HA</span>
            <span className={styles.appNameFull}>Hevy Analyzer</span>
          </span>
          {username && (
            <span id="active-profile" className={styles.activeUser}>@{username}</span>
          )}
        </div>

        {showPeriod && (
          <div className={styles.periodGroup} role="group" aria-label="Time period">
            {PERIOD_OPTIONS.map((days) => (
              <button
                key={days}
                className={`${styles.periodBtn} ${periodDays === days ? styles.active : ""}`}
                onClick={() => onPeriodChange(days)}
                aria-pressed={periodDays === days}
              >
                {days === 365 ? "1y" : `${days}d`}
              </button>
            ))}
          </div>
        )}

        <div className={styles.actions}>
          {onCompare && (
            <button className={styles.compare} onClick={onCompare}>
              Compare
            </button>
          )}
          <button className={styles.newSearch} onClick={onNewSearch}>
            <span className={styles.newSearchCompact}>Search</span>
            <span className={styles.newSearchFull}>New Search</span>
          </button>
        </div>
      </div>
    </header>
  );
}
